// removed by extract-text-webpack-plugin
module.exports = {"newScrap":"qempo_Scrap_newScrap-3mFNuxt"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/scrap/components/Scrap.scss
// module id = 2332
// module chunks = 0